const i18n = require("@/i18n");

module.exports = {
  id: "Stylable_StylableButton_1",
  preset: { rect: { width: 162, height: 75, x: 162, y: 0 }, tags: null },
  structure: {
    parent: "comp-knzvqsjj",
    style: {
      styleType: "custom",
      componentClassName: "wixui.StylableButton",
      style: {
        groups: {},
        properties: {
          "$st-css":
            ":import{\n    -st-from: 'wix-ui-santa/index.st.css';\n    -st-named: StylableButton\n}\n.root{\n    -st-extends: StylableButton;\n    transition: all 0.2s ease, visibility 0s;\n    background: rgba(0,0,0,0)\n}\n.root:hover{\n    background: value(site_1_1);\n    border: 0px solid value(site_1_5);\n    border-bottom: 0px solid value(site_1_5)\n}\n.root:hover::label{\n    color: value(site_1_5);\n    text-decoration-line: underline;\n    letter-spacing: 0.1em\n}\n.root:disabled{\n    background: rgba(226,226,226,0)\n}\n.root:disabled::label{\n    color: #8F8F8F\n}\n.root:disabled::icon{\n    fill: #8F8F8F\n}\n.root::container{\n    transition: inherit\n}\n.root::label{\n    transition: inherit;\n    color: #282626;\n    font-family: helvetica-w01-light,helvetica-w02-light,sans-serif;\n    font-weight: normal;\n    font-style: normal;\n    font-size: 17px;\n    letter-spacing: 0em\n}\n.root::icon{\n    transition: inherit;\n    width: 10px;\n    height: 10px;\n    fill: value(site_1_1);\n    display: none\n}\n.root:hover::icon{\n    fill: value(site_1_5)\n}",
        },
        propertiesSource: { "$st-css": "value" },
      },
      pageId: "",
      compId: "",
      type: "ComponentStyle",
      metaData: {
        isHidden: false,
        sig: "4ie-607",
        pageId: "c1dmp",
        schemaVersion: "1.0",
        isPreset: false,
      },
      skin: "wixui.skins.Skinless",
    },
    activeModes: {},
    data: {
      type: "StylableButton",
      metaData: {
        isHidden: false,
        sig: "mtq-2337",
        pageId: "c1dmp",
        schemaVersion: "1.0",
        isPreset: false,
      },
      label: i18n.translate("buttons_text_preset_read_more"),
      svgId: "b861b040274141de9c08999ec3b76edf.svg",
    },
    components: [],
    componentType: "wixui.StylableButton",
    id: "comp-klz3kcsg",
    layout: {
      x: 171,
      fixedPosition: false,
      y: 20,
      scale: 1,
      height: 40,
      rotationInDegrees: 0,
      width: 142,
    },
    type: "Component",
    props: {
      type: "StylableButtonProperties",
      metaData: { schemaVersion: "1.0", sig: "mtq-2303", pageId: "c1dmp" },
    },
    metaData: { sig: "4ie-605", pageId: "c1dmp" },
    skin: "wixui.skins.Skinless",
  },
};
